import React from 'react';
import { Badge } from '@neptune/shared/venus-ui';
import { useOrganizationMembers } from '@neptune/user-management-business-logic';

export const OrganizationPeopleBadge = () => {
  const { membersCount } = useOrganizationMembers();

  return <Badge>{membersCount}</Badge>;
};
